module.exports = __webpack_public_path__ + "assets/HKNova-SemiBold.woff";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-SemiBold.woff
// module id = 129
// module chunks = 0